import {storeToRefs} from 'pinia';
import type {RouteLocationNormalized} from 'vue-router';
import {defineNuxtRouteMiddleware, navigateTo, useNuxtApp} from '#app';
import {useRuntimeConfig} from '#imports';
import {useAuth} from '../store/auth.store';

export default defineNuxtRouteMiddleware((to) => {
    const nuxtApp = useNuxtApp();
    const {$pinia} = nuxtApp;

    const authStore = useAuth($pinia);
    const {isUmbrellaCompany} = storeToRefs(authStore);
    const runtimeConfig = useRuntimeConfig();

    function isTryingToAccessOutsideCompliance(to: RouteLocationNormalized): boolean {
        const baseURL = runtimeConfig.app.baseURL;
        const currentPath = baseURL === '/' ? to.path : baseURL + to.path;

        const allowList = [
            '/*/signout',
            '/emailvalidation/*',
            '/freelancer/company',
            '/freelancer/company/*',
            '/umbrella/company/',
            '/freelancer',
            '/project-payment/freelancer',
            '/invoicing/supplier/documents',
            '/*/signin',
        ];

        const forbiddenList = ['dashboard/freelancer'];
        return (
            !allowList.some((allowedPath: string) => new RegExp(allowedPath).test(currentPath)) ||
            forbiddenList.some((forbiddenPath) => new RegExp(forbiddenPath).test(currentPath))
        );
    }

    if (authStore.loggedIn && isUmbrellaCompany.value && isTryingToAccessOutsideCompliance(to)) {
        return navigateTo('/freelancer/company', {external: true});
    }
});
